import React, { useEffect, useReducer, useState } from 'react';
import TextInput from '../components/Common/TextInput';
import CallOut from '../components/Common/CallOut';
import Notification from '../components/Common/Notification';
import ActivityLoader from '../components/Common/ActivityLoader';
import { useAccounts } from '../DataStore/AccountsContext';
import ajaxAccountChart from '../util/remote/ajaxAccountChart';
import { useBanking } from '../DataStore/BankingContext';

const reducer = (state, action)=>{
        if(action.type === "RESET"){
            return {
                ...state,
                accountTitle: initialState.accountTitle,
                accountDescription: initialState.accountDescription
            }
        }
        return { ...state, [action.type]: action.value };
}

const initialState = {
        accountCategory:"",
        balanceAccount:false,
        isSubAccount:true,
        accountNumber:"",
        accountTitle:"",
        accountDescription:"",
        mainAccountId:"",
        accountListing: null,
        bankId:"",
        openingBalance:"",
        balanceDate:"",
        info:"",
        loading: false,
}

const NewAccount = () => {
    const [ currentNotify, setNotify ] = useState(null);
    const { 
        accountCategoryList, 
        getAccountCategories,  
        getChartOfAccounts, 
        toggleOpeningBalanceModal, 
        showOpeningBalanceModal, 
        dispatch: accountDispatch
    } = useAccounts();

    const {getBanks, bankListing} = useBanking();

    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(()=>{
        if(currentNotify){
            setTimeout(() => {
                setNotify(null);
            }, 5000);
        }
    }, [currentNotify]);

    useEffect(() => {
        getAccountCategories();
        getBanks();
    }, []);

    useEffect(() => {
        getCategoryAccounts();
    }, [state.accountCategory]);

    /**
     * Store new account draft in context
     */
    useEffect(()=>{
        accountDispatch({type: 'newAccountDraft', payload: state})
    }, [state]);

    useEffect(() => {
        if (state.mainAccountId) {
            if (state.mainAccountId.value * 1 === 1 || state.mainAccountId.value * 1 === 2) {
                dispatch({ type: 'balanceAccount', value: true });
            } else {
                dispatch({ type: 'balanceAccount', value: false });
            }
        }
    }, [state.mainAccountId]);

    const handleSave = async (event) => {
        event.preventDefault();
        if (state.loading) {
            return;
        }

        if (!state.accountCategory.value) {
            setNotify(<Notification type="danger" message="Enter account category and try again" />);
            return false;
        }

        if (state.isSubAccount && !state.mainAccountId.value) {
            setNotify(
                <Notification
                    type="danger"
                    message="This is a sub-account. Please select a main account and try again"
                />
            );
            return false;
        }

        if (state.balanceAccount && state.openingBalance > 0) {
            // Open balance date modal here
            toggleOpeningBalanceModal(true)
            return false;
        }

        dispatch({ type: 'loading', value: true });

        const server_response = await ajaxAccountChart.createAccount({
            account_name: state.accountTitle,
            account_number: state.accountNumber,
            category_id: state.accountCategory.value,
            description: state.accountDescription,
            main_account_id: state.mainAccountId.value,
            opening_balance: state.openingBalance,
            bank_id: state.bankId.value,
        }
        );
        dispatch({ type: 'loading', value: false });

        if (server_response.status === 'OK') {
            setNotify(<Notification type="success" message={server_response.message} />);
            dispatch({ type: 'RESET' });
             /**
             * Refresh data in context after the success notification has showed up to mitigate the re-render effect.
             */
             setTimeout(() => {
                getChartOfAccounts(true);
            }, 5000);
        } else {
            setNotify(<Notification type="danger" message={server_response.message} />);
        }
    };

    const getCategoryAccounts = async () => {
        dispatch({ type: 'accountListing', value: false });
        const server_response = await ajaxAccountChart.listAccountsForCategory(state.accountCategory.value);
        if (server_response.status === 'OK') {
            dispatch({ type: 'accountListing', value: server_response.details });
        } else {
            dispatch({ type: 'accountListing', value: '404' });
        }
    };


    const RenderAccountCategory = () => {
        const options = [];
        if (accountCategoryList && accountCategoryList !== '404') {
            accountCategoryList.map((item, key) =>
                options.push({ label: item.value + ' ' + item.category_name, value: item.category_id })
            );
        }

        return (
            <TextInput
                label="Account Category"
                type="select"
                leftIcon="fa-regular fa-folder"
                placeholder={state.accountCategory.label || 'Select account category....'}
                options={options}
                onChange={(item) => dispatch({ type: 'accountCategory', value: item })}
                leftComponent={<i className="fa-regular fa-folder link" onClick={getAccountCategories}></i>}
                loading={!accountCategoryList}
                wrap
            />
        );
    };

    const RenderAccountListing = () => {
        const options = [];
        if (Array.isArray(state.accountListing)) {
            state.accountListing.map((item, key) =>
                options.push({ label: item.account_number + ' ' + item.account_name, value: item.account_id })
            );
        }

        return (
            <TextInput
                label="Main Account (Parent Account)"
                type="select"
                leftIcon="fa fa-university"
                placeholder={state.mainAccountId.label || 'Select main account....'}
                options={options}
                onChange={(item) => dispatch({ type: 'mainAccountId', value: item })}
                leftComponent={<i className="fa fa-user-check" onClick={getCategoryAccounts}></i>}
                loading={!state.accountListing}
                wrap
            />
        );
    };


    const RenderBankField=()=>{

        const options=[];
        if(Array.isArray(bankListing)){
            bankListing.map((item, key)=>
                options.push({label:item.account_number + ' ' + item.bank_name, value:item.bank_id})
            )
        }
        
        return   <TextInput
                        label="Bank Account"
                        type="select" 
                        leftIcon="fa fa-university"
                        placeholder={state.bankId.label || "Select bank...."} 
                        options={options}
                        onChange={item => dispatch({type: 'bankId', value: item})}
                        leftComponent={<i className="fa fa-university" onClick={()=>getBanks(true)}></i>}
                        loading={!bankListing}
                        wrap
                        />
        
    }

    return (
        <div className="card-body">
            <CallOut
                title="Account"
                description="Create a new account to categorize and track your transactions. E.g. use '1001' for 'Cash Account' to track petty cash transactions."
            />
            {currentNotify}
            <form className="form-horizontal" method="post" onSubmit={handleSave}>
                <TextInput
                    type="number"
                    label="Account number"
                    placeholder="Account number"
                    leftIcon="fa fa-university"
                    value={state.accountNumber}
                    onChange={(e) => dispatch({ type: 'accountNumber', value: e.target.value })}
                    required
                    wrap
                />

                <TextInput
                    type="text"
                    label="Account title"
                    placeholder="Account title"
                    leftIcon="fa fa-user-check"
                    value={state.accountTitle}
                    onChange={(e) => dispatch({ type: 'accountTitle', value: e.target.value })}
                    required
                    wrap
                />

                <TextInput
                    type="textarea"
                    label="Account description"
                    placeholder="Account description. Eg. ( What does this account track ? )"
                    leftIcon="fa fa-list"
                    value={state.accountDescription}
                    onChange={(e) => dispatch({ type: 'accountDescription', value: e.target.value })}
                    required
                    wrap
                />

                {RenderAccountCategory()}

                {/* Sub-account Toggle */}
                <div className="form-check mb-3 mt-3">
                    <input
                        type="checkbox"
                        className="form-check-input"
                        id="isSubAccount"
                        checked={state.isSubAccount}
                        onChange={(e) => dispatch({ type: 'isSubAccount', value: e.target.checked })}
                    />
                    <label className="form-check-label" htmlFor="isSubAccount">
                        Is this a sub-account?
                    </label>
                </div>

                {/* Render Account Listing Conditionally */}
                {state.isSubAccount && RenderAccountListing()}


                {state.mainAccountId.value === "1" && RenderBankField()}

                    {state.balanceAccount && <TextInput
                            type="number"
                            label="Opening Balance"
                            placeholder="Enter Amount"
                            leftIcon="fa fa-credit-card"
                            value={state.openingBalance}
                            onChange={e => dispatch({type: 'openingBalance', value: e.target.value})} 
                            required
                            wrap
                            />}

                <div className="text-right">
                    {!state.loading && !showOpeningBalanceModal && <button type="submit" className="btn btn-lg btn-success">Confirm New Account</button>}
                    {state.loading && <ActivityLoader />}
                </div>
            </form>
        </div>
    );
};

export default NewAccount;

